/// <reference types="vite/client" />
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import {
  initializeAppCheck,
  ReCaptchaEnterpriseProvider,
} from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyDGYwIpu4JDcv0BahCSpZml-37f9IAZ3xY",
  authDomain: "breathfulnessapp.firebaseapp.com",
  projectId: "breathfulnessapp",
  storageBucket: "breathfulnessapp.firebasestorage.app",
  messagingSenderId: "690292137660",
  appId: "1:690292137660:web:804cdc7a8ad84e0b6d3ab9",
  measurementId: "G-2BF17LDYNQ",
};

const RECAPTCHA_V3_SITE_KEY = "6Lf4PSQtAAAAACAjhiUqtDrW_GmM8QhGUssFgZVa";

// Set this in the browser console during local dev to bypass
// App Check enforcement: self.FIREBASE_APPCHECK_DEBUG_TOKEN = true
// Then register the printed token in Firebase Console.
if (import.meta.env.DEV) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (globalThis as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

export const app = initializeApp(firebaseConfig);

export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider(RECAPTCHA_V3_SITE_KEY),
  isTokenAutoRefreshEnabled: true,
});

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "europe-west3");
